import _slicedToArray from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect } from 'react';
import useHandlerSetterRef from './shared/useHandlerSetterRef';
/**
 * Accepts an event name then returns a callback setter for a function to be performed when the event triggers.
 */

var useGlobalEvent = function useGlobalEvent(eventName, fn, opts) {
  var _useHandlerSetterRef = useHandlerSetterRef(fn),
      _useHandlerSetterRef2 = _slicedToArray(_useHandlerSetterRef, 2),
      handler = _useHandlerSetterRef2[0],
      setHandler = _useHandlerSetterRef2[1];

  handler.current = fn;
  useEffect(function () {
    var cb = function cb(event) {
      if (handler.current) {
        handler.current(event);
      }
    };

    if (handler && eventName) {
      window.addEventListener(eventName, cb, opts);
    }

    return function () {
      if (eventName) {
        window.removeEventListener(eventName, cb, opts);
      }
    };
  }, [eventName, opts]);
  return setHandler;
};

export default useGlobalEvent;